import type { IconProps } from './types';

export function Regata({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M92 48 Q100 44 108 48 L108 92 Q128 116 148 92 L148 48 Q156 44 164 48 L164 92 Q176 96 184 100 Q200 108 200 124 L200 208 Q200 216 192 216 L64 216 Q56 216 56 208 L56 124 Q56 108 72 100 Q80 96 92 92 Z" />
    </svg>
  );
}
